import React from "react";
import { Link } from "react-router-dom";
import { FaRegClock, FaRegEnvelope } from "react-icons/fa";

function PolicyPage({ className, title, summary, sections }) {
  return (
    <main className={`policy-page ${className}`}>
      <header className="policy-hero">
        <div className="policy-shell">
          <nav className="policy-breadcrumb" aria-label="Breadcrumb">
            <Link to="/">Home</Link>
            <span aria-hidden="true">/</span>
            <span aria-current="page">{title}</span>
          </nav>
          <p className="policy-eyebrow">Customer care</p>
          <h1>{title}</h1>
          <p className="policy-summary">{summary}</p>
          <p className="policy-updated">
            <FaRegClock aria-hidden="true" /> Last updated: September 3, 2026
          </p>
        </div>
      </header>

      <div className="policy-shell policy-layout">
        <aside className="policy-sidebar">
          <div className="policy-toc">
            <p className="policy-toc-title">On this page</p>
            <nav aria-label={`${title} sections`}>
              {sections.map((section) => (
                <a key={section.id} href={`#${section.id}`}>
                  {section.title}
                </a>
              ))}
            </nav>
          </div>

          <div className="policy-help">
            <FaRegEnvelope aria-hidden="true" />
            <div>
              <strong>Need help?</strong>
              <p>Our support team is ready to assist with your order.</p>
              <Link to="/contact">Contact us</Link>
            </div>
          </div>
        </aside>

        <article className="policy-content">
          {sections.map((section, index) => (
            <section id={section.id} key={section.id}>
              <div className="policy-section-heading">
                <span>{String(index + 1).padStart(2, "0")}</span>
                <h2>{section.title}</h2>
              </div>
              <div className="policy-section-body">{section.content}</div>
            </section>
          ))}

          <div className="policy-contact-card">
            <div>
              <span>Questions about this policy?</span>
              <strong>We are here to help.</strong>
            </div>
            <a href="mailto:support@dzcp896.com">support@dzcp896.com</a>
          </div>
        </article>
      </div>
    </main>
  );
}

export default PolicyPage;
